import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ViolationsPage } from './Violations';
import { SuspensionsPage } from './Suspensions';
import { AppealsPage } from './Appeals';
import routes from '../routes';

const AccountabilityRoutes: React.FC = () => {
  return (
    <Routes>
      <Route
        index
        element={<Navigate to={routes.accountabilityViolations} replace />}
      />
      <Route
        path={routes.accountabilityViolations}
        element={<ViolationsPage />}
      />
      <Route
        path={routes.accountabilitySuspensions}
        element={<SuspensionsPage />}
      />
      <Route path={routes.accountabilityAppeals} element={<AppealsPage />} />
    </Routes>
  );
};

export default AccountabilityRoutes;
